import { useEffect } from "react";

export default function Toast({ message, type = "info", onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast toast--${type} animate-slideIn`}>
      <span className="toast__icon">{type === "success" ? "✅" : type === "error" ? "❌" : type === "warning" ? "⚠️" : "ℹ️"}</span>
      <span className="toast__message">{message}</span>
      <button onClick={onClose} className="toast__close">✕</button>
    </div>
  );
}